// Fixed template of inspection "Main Information" fields. The edit dialog shows
// ALL of these; on save only the filled ones are kept. Derived from the
// ISYBAU/DWA mapping (see D:\doc\edit\resources\inspection_info_mapping.json):
// `label` is what the inspector sees on screen, `isybauField`/`dwaField` are the
// export targets, `type` drives the input control.
//
// Deduplicated by on-screen `label` (e.g. Entwaesserungsart/Kanalart both map to
// the single "Kanalsystem" field).

export type MainInfoFieldType = "string" | "date" | "time";

export interface MainInfoField {
  label: string; // on-screen label and the key stored in main information
  isybauField: string;
  dwaField: string;
  type: MainInfoFieldType;
}

export const MAIN_INFO_FIELDS: MainInfoField[] = [
  { label: "Kanalsystem", isybauField: "Entwaesserungsart", dwaField: "HG302", type: "string" },
  { label: "Datum", isybauField: "Inspektionsdatum", dwaField: "HI104", type: "date" },
  { label: "Insp.-Richtung", isybauField: "Inspektionsrichtung", dwaField: "HI101", type: "string" },
  { label: "Inspektionsverfahren", isybauField: "Inspektionsverfahren", dwaField: "HI103", type: "string" },
  { label: "Grund", isybauField: "Inspektionszweck", dwaField: "HI004", type: "string" },
  { label: "unterer Schacht", isybauField: "KnotenAblauf", dwaField: "HG004", type: "string" },
  { label: "oberer Schacht", isybauField: "KnotenZulauf", dwaField: "HG003", type: "string" },
  { label: "Haltungslänge", isybauField: "Laenge", dwaField: "HG310", type: "string" },
  { label: "Material", isybauField: "Material", dwaField: "HG304", type: "string" },
  { label: "Operator", isybauField: "NameUntersucher", dwaField: "HI112", type: "string" },
  { label: "Haltung", isybauField: "Objektbezeichnung", dwaField: "HG001", type: "string" },
  { label: "Ortschaft", isybauField: "Ortsteilname", dwaField: "HG104", type: "string" },
  { label: "Profilart", isybauField: "Profilart", dwaField: "HG305", type: "string" },
  { label: "Breite", isybauField: "Profilbreite", dwaField: "HG306", type: "string" },
  { label: "Höhe", isybauField: "Profilhoehe", dwaField: "HG307", type: "string" },
  { label: "Rohrlänge", isybauField: "Rohrlaenge", dwaField: "HG314", type: "string" },
  { label: "Strasse", isybauField: "Strassenname", dwaField: "HG102", type: "string" },
  { label: "Uhrzeit", isybauField: "Uhrzeit", dwaField: "HI105", type: "time" },
  { label: "Videoband", isybauField: "Videoablagereferenz", dwaField: "HI115", type: "string" },
  { label: "Wetter", isybauField: "Wetter", dwaField: "HI106", type: "string" },

  // Video properties rather than inspection data, so they have no entry in
  // inspection_info_mapping.json. They are collected here because nothing else records
  // them: the analysis JSON carries only its own 0.5 s sampling interval, not the video's
  // frame rate. With a frame rate the ISYBAU export can reference each observation by real
  // frame number instead of falling back to a second count; with the frame count as well it
  // can also emit the film's Frame block.
  { label: "Bildrate", isybauField: "Bildrate", dwaField: "", type: "string" },
  { label: "Bildanzahl", isybauField: "Bildanzahl", dwaField: "", type: "string" },
];
